var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.owners, function(person, index) {
        return _c("Person", {
          key: "owners-" + index,
          attrs: {
            person: person,
            icon: true,
            type: "owner",
            "icon-class": "glyphicon-certificate"
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.attns, function(person, index) {
        return _c("Person", {
          key: "attns-" + index,
          attrs: {
            person: person,
            icon: true,
            type: "attn",
            "icon-class": "glyphicon-user"
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.genericPeople, function(person, index) {
        return _c("Person", {
          key: "generic-" + index,
          attrs: { person: person, type: "generic", icon: false }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.blankPeople, function(person, index) {
        return _c("PersonSkeleton", {
          key: "skeleton-" + index,
          attrs: { icon: false }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }